import React, { Component } from 'react';

import PropTypes from 'prop-types';

import { VFScreen } from '@vfgroup-oneplatform/foundation/Components';
import { withTheme, LightThemeColors } from '@vfgroup-oneplatform/foundation/Components/Themes';

import FrameworkTestKeys from '../../../FrameworkTestKeys';
import AddOnsShop from '../../Containers/AddOnsShop';

class AddOnsShopScreen extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { onClose, onBack } = this.props;
    return (
      <VFScreen
        title={'addons_screen_title'}
        onBack={onBack}
        showBack
        onClose={onClose}
        closeButtonTestID={FrameworkTestKeys.AddOnsShopScreenClose}
        withHeaderSpace
      >
        <AddOnsShop {...this.props} />
      </VFScreen>
    );
  }
}
AddOnsShopScreen.defaultProps = {
  theme: LightThemeColors,
};
AddOnsShopScreen.propTypes = {
  onClose: PropTypes.func,
  onBack: PropTypes.func,
};
export default withTheme(AddOnsShopScreen);
